import React, {useEffect, useState} from 'react';
import Layout from "../components/Layout";
import ActiveTripHeader from "../components/ActiveTripHeader";
import Header from "../components/Header";
import {mdiAlertCircle, mdiCheckCircle} from "@mdi/js";
import Icon from "@mdi/react";
import logoDarkMode from "../assets/header-dark.png";
import logoLightMode from "../assets/header-light.png";
import {useManageContext} from "../App";
import TripAddresses from "../components/TripAddresses";
import {AddressType, findNextStop, isAddressCompleted} from "../types/Address";
import TotalTripInfo from "../components/TotalTripInfo";
import {Trip} from "../types/Trip";

export default function ActiveTrip() {

    const {isDarkMode, trip} = useManageContext();
    const [addresses, setAddresses] = useState<AddressType[]>([]);
    const [ldm, setLdm] = useState<object>({});
    const [currentLdm, setCurrentLdm] = useState(0);

    useEffect(() => {
        if (trip) {
            setAddresses(trip.Address.filter((Address: AddressType) => !isAddressCompleted(Address)));
            setTheCurrentLdm(trip);
        }
    }, [trip]);

    useEffect(() => {
        if (!trip || currentLdm === 0) {
            return;
        }

        let lmd: object = {};
        let truckTrailerLdmSpaceLeft = currentLdm;

        trip.Address.forEach((Address) => {
            if (isAddressCompleted(Address)) {
                return;
            }
            truckTrailerLdmSpaceLeft = calculateLdm(Address, truckTrailerLdmSpaceLeft);
            lmd = {
                ...lmd,
                ['TripAddresses_' + Address.AddressId]: truckTrailerLdmSpaceLeft,
            };
        });

        setLdm(lmd);
    }, [currentLdm, trip]);

    const setTheCurrentLdm = (Trip: Trip) => {
        let truckTrailerLdmSpace = Trip.TruckTrailerLdmSpace;

        Trip.Address.forEach((Address) => {
            // Skip pending addresses
            if (!isAddressCompleted(Address)) {
                return;
            }
            truckTrailerLdmSpace = calculateLdm(Address, truckTrailerLdmSpace);
        });

        setCurrentLdm(truckTrailerLdmSpace);
    }

    const calculateLdm = (Address: AddressType, truckTrailerLdmSpace: number) => {
        switch (Address.TaskType) {
            case 1:
                return Math.round((truckTrailerLdmSpace - Address.AddressTotalLdm) * 100) / 100;
            case 2:
                return Math.round((truckTrailerLdmSpace + Address.AddressTotalLdm) * 100) / 100;
            default:
                return truckTrailerLdmSpace;
        }
    }

    if (typeof trip === "undefined") {
        return <div className="main d-flex justify-content-center align-items-center">
            <div className="text-center">
                <img className="mb-3" src={isDarkMode ? logoDarkMode : logoLightMode} alt="CLOUDEX Tracking" style={{maxHeight: 35}}/>
                <div className="d-flex">
                    <div className="alert alert-danger">
                        <Icon path={mdiAlertCircle} size={1}/> <strong>No Trip found!</strong>
                        <p className="mt-2 mb-0">Please make sure you are using the correct url to access your trip.</p>
                    </div>
                </div>
            </div>
        </div>;
    }

    return (
        <Layout>
            <Header />
            <ActiveTripHeader trip={trip}/>
            <TotalTripInfo trip={trip} ldm={currentLdm}/>
            {addresses.length === 0 && <div className="px-4 mt-4">
                <div className="alert alert-success">
                    <p className="mb-0"><Icon path={mdiCheckCircle} size={1}/> This trip has been completed!</p>
                </div>
            </div>}
            {addresses.map((Address: AddressType) => {
                return <TripAddresses
                    key={'TripAddresses_' + Address.AddressId}
                    Address={Address}
                    onlyWithPendingTasks={true}
                    // @ts-ignore
                    ldm={ldm['TripAddresses_' + Address.AddressId]}
                    isNextStop={!trip || findNextStop(trip.Address)?.AddressId === Address.AddressId}
                />;
            })}
        </Layout>
    );
}